// @ts-expect-error -- untyped module
import mfaImage from "@/assets/mfa-image.svg";

import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useContext } from "react";
import { MFAContext, MfaViewState } from "@/context/mfa-provider";
import useUserInfo from "@/hooks/use-user-info";

const MfaEnable = () => {
  const { setViewState } = useContext(MFAContext);
  const userInfo = useUserInfo();

  const handleMfaEmail = () => {
    // userInfo.email = null;
    if (!userInfo.email) setViewState(MfaViewState.ADD_EMAIL);
    else setViewState(MfaViewState.REQUEST_OTP);
  };

  return (
    <div className="flex size-full flex-col justify-between gap-8">
      <div className="grid grid-cols-1 place-items-center gap-6">
        <img src={mfaImage} className="size-20" alt="" />
        <Label className="text-lg font-bold">
          Enable Multi Factor Authentication
        </Label>
        <div className="flex flex-col gap-1 text-center">
          <Label className="text-sm/6">
            Please secure your account now with MFA
          </Label>
        </div>
      </div>
      <div className="flex justify-center gap-4">
        <Button
          type="button"
          className="w-32 rounded-sm"
          onClick={handleMfaEmail}
        >
          Enable
        </Button>
      </div>
    </div>
  );
};

export default MfaEnable;
